module.exports = __webpack_public_path__ + "static/img/7.a947bfe6.jpg";